import { getDistanceInKm } from '@/helpers/filters'

export const filterRecommendedHotels = (hotels, hotelsFromCMS) => {
  if (hotelsFromCMS.length > 0) {
    return hotels.filter(hotel => hotelsFromCMS.includes(hotel.hotelId))
  } else {
    return hotels.filter((hotel) => hotel.budgetHotel.isRecommended)
  }
}

export const getSixRecommendedHotels = (allRecommendedHotels) => {
  let recommendedHotels = []
  if (allRecommendedHotels.length > 6) {
    for (let ix = 0; ix < 6; ix++) {
      let randomIndex = Math.floor(Math.random() * allRecommendedHotels.length)
      recommendedHotels.push(allRecommendedHotels[randomIndex])
      allRecommendedHotels.splice(randomIndex, 1)
    }
  } else {
    recommendedHotels = allRecommendedHotels
  }
  return recommendedHotels
}

export const fixCityCenterCoords = ({ congress, lat, lng }) => {
  congress.cityCenterLat = lat
  congress.cityCenterLng = lng
}

export const addDistancesToHotels = ({ hotels, cityCenterLat, cityCenterLng, congressLat, congressLng }) => {
  hotels.forEach(hotel => {
    hotel.distanceToCityCenter = round(getDistanceInKm(hotel.lat, hotel.lng, cityCenterLat, cityCenterLng))
    hotel.distanceToCongress = round(getDistanceInKm(hotel.lat, hotel.lng, congressLat, congressLng))
  })
}

export const setCssProperties = site => {
  Object.entries({
    VUE_APP_PRIMARY_COLOR: '--congress-color',
    VUE_APP_HOVER_COLOR: '--congress-color-hover',
    VUE_APP_HERO_IMAGE: '--congress-background-image',
    VUE_APP_ICON_CIRCULAR_CHECK: '--congress-icon-check',
    VUE_APP_ICON_WALKING_DISTANCE: '--congress-icon-walking-distance',
    VUE_APP_ICON_CITY_CENTER: '--congress-icon-city-center',
    VUE_APP_ICON_HEADQUARTERS: '--congress-icon-headquarters',
    VUE_APP_IMAGE_IE_BANNER: '--congress-image-internet-explorer'
  }).forEach(([key, value]) => {
    if (site.hasOwnProperty(key)) {
      const propValue = value.indexOf('color') === -1 ? `url(${site[key]})` : site[key]
      document.documentElement.style.setProperty(value, propValue)
    }
  })
}

const round = (distance) => Math.round(distance * 10) / 10
